import {
  SEARCH_RESULTS_REQUEST,
  SEARCH_RESULTS_SUCCESS,
  SEARCH_RESULTS_FAILURE,
} from '../actions/types';
import { FETCH_PAGE_REQUEST, FETCH_PAGE_SUCCESS } from '../../../routes/actions/types';
import { SEARCH } from '../../../routes/config/pageTypes';

const initialState = {
  results: [],
  totalPages: 0,
  loading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PAGE_REQUEST: {
      if (action.pageType === SEARCH) {
        return { ...initialState, loading: true };
      }
      return state;
    }
    case FETCH_PAGE_SUCCESS: {
      if (action.pageType === SEARCH) {
        const { data, loading } = action;
        return {
          results: data.results,
          totalPages: data.totalPages,
          loading,
        };
      }
      return state;
    }
    case SEARCH_RESULTS_FAILURE:
      return { ...initialState };
    case SEARCH_RESULTS_REQUEST:
      return {
        ...state,
        loading: action.loading,
      };
    case SEARCH_RESULTS_SUCCESS:
      return {
        results: action.results,
        totalPages: action.totalPages,
        loading: false,
      };
    default:
      return state;
  }
};
